enum ListenerType {
  ALL = 'All',
  LISTENERS = 'Listeners',
  LISTENING_TO = 'Listening To',
}

export default ListenerType;
